import { Injectable } from '@angular/core';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import Feature from 'ol/Feature';
import * as turf from '@turf/turf';
import { convertTypeAcquisitionFromJson, getTokenSourceMapRange } from 'typescript';
import { FeatureCollection, Point, point, Polygon } from '@turf/turf';

@Injectable({
  providedIn: 'root',
})
export class SpatialService {
  private readonly _componentName = 'SpatialService';
  private wktFormat = new WKT();
  private geojsonFormat = new GeoJSON();

  constructor() {}

  /**
   * Returns the centroid of a WKT Polygon Geometry
   * @param wkt
   * @param dataProjection
   * @returns
   */
  public getWKTCentroid(wkt: string, dataProjection: string) {
    const feature: Feature = this.wktFormat.readFeature(wkt, {
      dataProjection,
      featureProjection: dataProjection,
    });

    const geoJsonFeature = this.geojsonFormat.writeFeatureObject(feature);
    // console.log(`${this._componentName}.getWKTCentroid geoJsonFeature=`,geoJsonFeature);
  
      // @ts-ignore
    const centroid = turf.centroid(geoJsonFeature);

    console.log(`${this._componentName}.getWKTCentroid centroid=`, centroid);

    return centroid;
  }

  /**
   * Converts an envelope to a GeoJSON polygon
   * @param extent
   * @param srid
   * @returns
   */
  public getEnvelopeAsPolygon(extent: number[], srid: number) {
    console.log(`${this._componentName}.getEnvelopeAsPolygon  extent=`, extent);

    let poly = {
      coordinates: [
        [
          [extent[0], extent[1]],
          [extent[2], extent[1]],
          [extent[2], extent[3]],
          [extent[0], extent[3]],
          [extent[0], extent[1]],
        ],
      ],
      type: 'Polygon',
    } as Polygon;

    // console.log(poly);

    return poly;
  }

  /**
   * Gets an extent array
   * @param polygonGeometry (GeoJSON Polygon)
   */
  public getPolygonExtent(polygonGeometry: object) {
    if (!polygonGeometry) {
      return null;
    }
  }

  /**
   * Unions multiple features/polygons together. workaround for broken 6.x union with multiple polygon param - https://github.com/Turfjs/turf/issues/1900
   * @param thingsToUnion 
   * @returns 
   */
  public multiUnion(thingsToUnion: Array<turf.Feature<turf.Polygon | turf.MultiPolygon> | turf.Polygon | turf.MultiPolygon>) {
    const [firstThing, ...remainingThings] = thingsToUnion;
    if (!firstThing) {
      throw new Error('Expected at least one feature or geometry, got none');
    }

    let result = firstThing.type === 'Feature' ? firstThing : turf.feature(firstThing);

    for (const remainingThing of remainingThings) {
      try {
        result = turf.union(result, remainingThing);
      } catch (error) {
        console.error(error);
        
        // throw error;
      }}
    return result;
  }
}
